import { Route } from '@angular/router';
import { ParametersListComponent } from './ui/parameters-list/parameters-list.component';

const parametersRoutes: Route[] = [
    {
        path: 'parameters',
        component: ParametersListComponent,
    },
];

export default parametersRoutes;
